const MAX_TARGET_URL_LENGTH = 8192;

export function matchesUrlPattern(
  rawPattern: string | null | undefined,
  rawUrl: string
): boolean {
  const urlPattern = rawPattern?.trim();
  if (!urlPattern) return false;
  if (rawUrl.length > MAX_TARGET_URL_LENGTH) return false;

  try {
    const anchoredPattern = urlPattern.startsWith("^")
      ? urlPattern
      : `^${urlPattern}`;
    const regex = new RegExp(anchoredPattern);
    if (regex.test("https://example.invalid/")) return false;
    const url = new URL(rawUrl.includes("://") ? rawUrl : `https://${rawUrl}`);
    return regex.test(url.href);
  } catch {
    return false;
  }
}
